import { render, staticRenderFns } from "./EditTaskItem.vue?vue&type=template&id=1de11916&scoped=true"
import script from "./EditTaskItem.vue?vue&type=script&lang=js"
export * from "./EditTaskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de11916",
  null
  
)

export default component.exports